import { render, staticRenderFns } from "./DeleteCommentField.vue?vue&type=template&id=58dc6eac&scoped=true&"
import script from "./DeleteCommentField.vue?vue&type=script&lang=ts&"
export * from "./DeleteCommentField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc6eac",
  null
  
)

export default component.exports